import React from 'react'
import styled, { css } from 'styled-components'
import { breakpoint } from '../layout/styles'

const itemsStackBreakpoint = '(min-width: 520px)';

interface ItemInterface {
  heading: string,
  text: string
}

interface TwoColumnStatsProps {
  data: {
    vertical_spacing: boolean,
    items: ItemInterface[]
  }
}

const TwoColumnStats = ({ data }: TwoColumnStatsProps) => {
  const { items } = data;
  return (
    <Root spacing={!!data.vertical_spacing}>
      <Items totalItems={items?.length}>
        {items?.length > 0 && items.map((item: ItemInterface, index: number) => {
          return (
            <Item key={index}>
              <Heading>{item.heading}</Heading>
              <Text>{item.text}</Text>
            </Item>
          )
        })}
      </Items>
    </Root>
  );
};

// Explicitly define the type for the `spacing` prop in the styled component
interface RootProps {
  spacing: boolean;
}

const Root = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'spacing'
})<RootProps>`
  ${props => props.spacing && css`
    margin: 3rem 0;
    @media screen and ${breakpoint.desktop} {
      margin: 3.5rem 0 4.5rem 0;
    }
  `}
`

const Items = styled.div`
  width: 100%;
  max-width: 66rem;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  gap: 3rem 0;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;

  ${(props) => props.totalItems && props.totalItems > 2 && css`
    justify-content: center;
  `}
  @media screen and ${itemsStackBreakpoint} {
    gap: 4rem 0;
  }
`

const Item = styled.div`
  width: 100%;
  text-align: center;
  @media screen and ${itemsStackBreakpoint} {
    width: 45%;
  }
`

const Heading = styled.h3`
  color: var(--text);
  font-size: 40px;
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 1rem;
  @media screen and ${breakpoint.tablet} {
    font-size: 48px;
  }
`

const Text = styled.p`
  color: var(--text);
  font-size: 16px;
  line-height: 110%;
  font-weight: 400;
  margin: 0;
  @media screen and ${breakpoint.tablet} {
    font-size: 20px;
  }
  @media screen and ${breakpoint.desktop} {
    font-size: 22px;
  }
`

export default TwoColumnStats;